import React from "react";
import "../../assets/css/vendor.bundle.css";
import "../../assets/css/style.css";
import "../../assets/css/theme.css";
import TrendingViewChart from "../tradingview_chart/TradingViewChart";
import MediumWidget from "../medium_widget/MediumWidget";
import ForexCrossRatesWidget from "../forexcrossrates_widget/ForexCrossRatesWidget";
import Navbar from "../common/NavBar";
import Footer from "../common/Footer";
import { Helmet } from "react-helmet-async";

const DigitalCurrencies = () => {
    return (
        <div>
            <Helmet>
                <title>Digital Currencies</title>
            </Helmet>
            <div className="site-header header-s1 is-sticky">
                <Navbar />
                {/* Banner/Slider */}
                <div className="page-head section row-vm light has-bg-image">
                    <div className="imagebg bg-image-loaded" style={{ backgroundImage: `url(${require('../../assets/images/page-inside-bg.jpg')})` }}>
                        <img
                            src={require("../../assets/images/page-inside-bg.jpg")}
                            alt="page-head"
                        />
                    </div>
                    <div className="container">
                        <div className="row text-center">
                            <div className="col-md-12">
                                <h2>Digital Currencies</h2>
                                <div className="page-breadcrumb">
                                    <ul className="breadcrumb">
                                        <li>
                                            <a href="/">Markets</a>
                                        </li>
                                        <li className="active">
                                            <span>Digital Currencies</span>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* #end Banner/Slider */}
            </div>
            {/*Section */}
            <div className="section section-pad bg-grey">
                <div className="container">
                    <h2>
                        What are the Benefits of Trading Cryptocurrency CFDs?
                    </h2>
                    <div class="gaps size-3x"></div>
                    <div className="row row-vm forex-p">
                        <div className="col-md-6">
                            <div className="text-block text-left">
                                <p>
                                    Are you prepared to join the monetary revolution? With a AFC Trades trading account, you may trade the most prominent cryptocurrencies
                                    such as Bitcoin, Ethereum, XRP (Ripple), Bitcoin Cash, and Litecoin in the cryptocurrency industry. No digital wallet is required,
                                    and our cryptocurrency CFD trading platforms enable you to trade on both increasing and decreasing values.
                                </p>
                            </div>

                            {/* <div className="trendingview-chart res-m-bttm">
                                <TrendingViewChart />
                            </div> */}
                        </div>
                        <div className="col-md-6">
                            <div className="text-block text-left">
                                <h4>What are the advantages of trading cryptocurrency?</h4>
                                <ul>
                                    <li>You can trade without having to use a cryptocurrency wallet.</li>
                                    <li>It's a fantastic method to broaden your investment portfolio.</li>
                                    <li>The price of cryptocurrency is unrelated to any central bank or financial instrument.</li>
                                    <li>In a market that is open 24 hours a day, 5 days a week, you can trade increasing and decreasing prices.</li>
                                    <li>Low spreads and leveraged trading.</li>
                                </ul>


                            </div>

                            {/* <div className="trendingview-chart res-m-bttm">
                                <TrendingViewChart />
                            </div> */}
                        </div>
                    </div>
                    <p>AFC Trades is much more than just a cryptocurrency trading platform! We also provide Forex, commodities, and other financial services.
                        Shares and indices with low spreads and unrivalled trading conditions.</p>
                </div>
            </div>
            {/*Section */}

            {/*Section */}
            <div className="section section-pad">
                <div className="container">
                    <h2>What is the best cryptocurrency trading platform?</h2>
                    <h4>The most widely used trading platform on the planet.</h4>
                    <div class="gaps size-3x"></div>
                    <div className="row row-vm">
                        <div className="col-md-5 res-m-bttm">
                            <div className="text-block text-left">

                                <p>
                                    Learn about the advantages of trading cryptocurrencies on one of the most advanced trading platforms accessible.
                                    Our trading platform is the best cryptocurrency trading platform,
                                    and it‘s available on both desktop and mobile devices.
                                </p>
                                <ul>
                                    <li>The interface can be customised, including the colours of technical indicators.</li>
                                    <li>Trading with a single click.</li>
                                    <li>MarketWatch.</li>
                                    <li>Live pricing broadcasting is available on both Live and Demo accounts.</li>
                                    <li>Expert Consultants (EAs).</li>
                                    <li>Alerts that can be customised.</li>
                                    <li>iOS, Android, and Mac devices are all supported.</li>
                                </ul>

                                <a href="#" className="btn btn-alt">
                                    Read More
                                </a>
                            </div>
                        </div>
                        <div className="col-md-6 col-md-offset-1">
                            <div className="video-block round">
                                <img
                                    src={require("../../assets/images/service-thumb-cc.jpg")}
                                    alt="CryptoCoin Overview"
                                    className="img-shadow"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/*End Section */}

            {/*Section */}
            <div className="section section-pad bg-grey">
                <div className="container">
                    <div className="row row-vm">
                        <div className="col-md-6 ">
                            <div className="video-block round">
                                <img
                                    src={require("../../assets/images/bitcoin-a.jpg")}
                                    alt="CryptoCoin Overview"
                                    className="img-shadow"
                                />
                            </div>
                        </div>
                        <div className="col-md-5 res-m-bttm col-md-offset-1">
                            <div className="text-block text-left">
                                <h2>Benefits of Trading Cryptocurrency CFDs?</h2>
                                <p>
                                    CFDs (Contracts for Difference) trading on cryptocurrencies is a novel approach to trade this
                                    unpredictable market. For positions against the US Dollar and the Great Britain Pound, AFC Trades
                                    offers cryptocurrency CFDs in significant assets such as Bitcoin, XRP (Ripple), Bitcoin Cash,
                                    Litecoin, and Ethereum.
                                    <br />
                                    <br />
                                    Since it is difficult to keep track of all of the businesses listed on a stock exchange,
                                    traders turn to index trading. They can assess the overall success of the country's stock market
                                    and the economy in general using trade indices. Traders profit from the price fluctuations of
                                    various financial instruments indices by betting on the increase in value of the indices.
                                </p>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
            {/*End Section */}
            <Footer />
        </div>
    );
};

export default DigitalCurrencies;
